import React, { useEffect, useState, useCallback } from 'react';
import { TextField } from '@mui/material';
import { useGlobalStyles } from 'utils';
import { ErrMessage } from '../messages';
import { inputsStyle } from './styles';

/**
 * Applies a mask pattern to a raw value.
 * '9' in the mask means any digit. Other characters are literals.
 */
const applyMask = (rawValue, mask) => {
    const digits = (rawValue || '').replace(/[^0-9]/g, '');
    let result = '';
    let digitIndex = 0;

    for (let i = 0; i < mask.length && digitIndex < digits.length; i++) {
        if (mask[i] === '9') {
            result += digits[digitIndex];
            digitIndex++;
        } else {
            result += mask[i];
        }
    }

    return result;
};

export const MaskInput = ({ name, label, value, disabled, handleChange, error, mask, styles, className, noErrorMessage, uiType }) => {
    const globalWrappers = useGlobalStyles();
    const classes = inputsStyle();
    const currentMask = mask || '(999) 999-9999';
    const [currentValue, setCurrentValue] = useState('');

    useEffect(() => {
        setCurrentValue(value || '');
    }, [value]);

    const displayValue = applyMask(currentValue, currentMask);

    const maxDigits = (currentMask.match(/9/g) || []).length;

    const onInputChange = useCallback(
        (e) => {
            const raw = e.target.value.replace(/[^0-9]/g, '').slice(0, maxDigits);
            setCurrentValue(raw);
            if (handleChange) {
                handleChange({
                    target: {
                        name,
                        value: raw,
                    },
                });
            }
        },
        [handleChange, name, maxDigits]
    );

    return (
        <div className={globalWrappers.simpleInput} style={{ display: 'flex', flexDirection: 'column', width: '100%', ...styles }}>
            <TextField
                disabled={disabled}
                variant={'outlined'}
                label={label}
                name={name}
                value={displayValue}
                onChange={onInputChange}
                className={uiType ? classes.noChipLoads : className ? className : classes.inputTextField}
                error={error}
            />
            {!noErrorMessage && (
                <div style={{ position: 'relative' }}>
                    <ErrMessage text={error} />
                </div>
            )}
        </div>
    );
};
